import { ITypedReduxAction } from '../../types/redux/actionType';
import { TThunkAction } from '../../types/redux/thunk';
import { getFilteredResidentialComplexes } from '../../services/getFilteredResidentialComplexes';
import { ERoom, IFilter } from '../../types/filter';
import { DEFAULT_DEADLINE_VALUE } from '../../reducers/filter';
import { getSubdomain } from '../../selectors';

export enum EResidentialComplexesIdsTypes {
  ResidentialComplexesIdsChange = 'RESIDENTIAL_COMPLEXES/CHANGE_IDS',
}

export type TResidentialComplexesIdsChange = ITypedReduxAction<
  EResidentialComplexesIdsTypes.ResidentialComplexesIdsChange,
  number[]
>;

export function residentialComplexesIdsChange(filter: IFilter): TThunkAction<Promise<void>> {
  return async (dispatch, getState, { httpApi }) => {
    try {
      const state = getState();
      const residentialComplexesIds = await getFilteredResidentialComplexes({
        httpApi,
        subdomain: getSubdomain(state),
        parameters: {
          buildYear: filter.deadline === DEFAULT_DEADLINE_VALUE ? undefined : filter.deadline,
          handOver: filter.readyApartments,
          hasDecoration: filter.apartmentsWithDecoration,
          location: filter.location as number,
          priceMax: filter.maxPrice,
          priceMin: filter.minPrice,
          totalAreaMax: filter.maxArea,
          totalAreaMin: filter.minArea,
          room: (filter.rooms.includes(ERoom.ThreeRoom)
            ? [...filter.rooms, 'fourRoom', 'fiveRoom', 'large']
            : filter.rooms) as never,
        },
      });

      dispatch({
        type: EResidentialComplexesIdsTypes.ResidentialComplexesIdsChange,
        payload: residentialComplexesIds,
      });
    } catch (error) {
      console.error(error);
    }
  };
}
